/* @flow */
import idx from 'idx';
import React from 'react';
import gql from 'graphql-tag';
import { pick } from 'lodash';
import { graphql } from 'react-apollo';

type Props = {
  uuid: string,
  mutate: Function,
  children: Function,
  data: ReactApolloData<ContentSourceProviderContainerQuery>,
};

const UPDATABLE = [
  'title',
  'providerIconUrl',
  'organizationUUID',
  'contentWebhookUrl',
  'enabledByProvider',
  'bigPreviewWebhookUrl',
  'productLongDescription',
  'productShortDescription',
];

const DEFAULTS = {
  title: '',
  providerIconUrl: '',
  contentWebhookUrl: '',
  enabledByProvider: false,
  bigPreviewWebhookUrl: '',
  productLongDescription: '',
  productShortDescription: '',
};

class ContentSourceProviderContainer extends React.Component<Props, {}> {
  getContentSourceProvider = () => {
    return idx(this.props, _ => _.data.contentSourceProvider);
  };

  update = (attributes: *) => {
    const mutationInput = pick(
      {
        ...DEFAULTS,
        ...(this.getContentSourceProvider() || {}),
        ...attributes,
        organizationUUID: this.props.uuid,
      },
      UPDATABLE
    );

    return this.props
      .mutate({
        variables: {
          input: mutationInput,
        },
      })
      .then(result => {
        const error = idx(result, _ => _.data.updateContentSourceProvider.error.message);

        if (error) {
          throw new Error(error);
        } else {
          return result;
        }
      });
  };

  render() {
    return this.props.children({
      contentSourceProvider: this.getContentSourceProvider(),
      loading: this.props.data.loading,
      update: this.update,
    });
  }
}

const withTheContentSourceProviderMutation = graphql(
  gql`
    mutation UpdateContentSourceProvider($input: UpdateContentSourceProviderInput) {
      updateContentSourceProvider(input: $input) {
        contentSourceProvider {
          title
          providerKey
          providerIconUrl
          enabledByRemind
          enabledByProvider
          contentWebhookUrl
          bigPreviewWebhookUrl
          productLongDescription
          productShortDescription
        }
        error {
          code
          message
        }
      }
    }
  `
);

export const GET_CONTENT_SOURCE_PROVIDER_QUERY = gql`
  query ContentSourceProviderContainer($uuid: String!) {
    contentSourceProvider(organizationUUID: $uuid) {
      title
      providerKey
      providerIconUrl
      enabledByRemind
      enabledByProvider
      contentWebhookUrl
      bigPreviewWebhookUrl
      productLongDescription
      productShortDescription
    }
  }
`;

const withTheContentSourceProvider = graphql(GET_CONTENT_SOURCE_PROVIDER_QUERY, {
  options: ({ uuid }) => ({
    fetchPolicy: 'network-only',
    variables: { uuid },
  }),
});

export { ContentSourceProviderContainer };
export default withTheContentSourceProviderMutation(
  withTheContentSourceProvider(ContentSourceProviderContainer)
);
